var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"prefetch-image",attrs:{"src":_vm.imgSrc}})
}
var staticRenderFns = []

export { render, staticRenderFns }